export const ADMIN = 'admin';
export const SENDER = 'sender';
export const SENDER_ACCESS_CONTROL = 'geo_send_alert';
export const MOBILE = 'mobile';
